const ReviewCardSkeleton = () => {
  return (
    <div className="border rounded-lg sm:rounded-[12px] flex flex-col gap-4 sm:gap-6 border-light-blue p-4 sm:p-6 bg-white animate-pulse">
      <div className="flex flex-col gap-3">
        <div className="flex flex-row gap-4 items-center">
          <div className="flex justify-center items-center w-[64px] h-[64px] rounded-full bg-gray-300 "></div>
          <div className="flex flex-col gap-2">
            <div className="h-4 w-32 bg-gray-300 rounded "></div>
            <div className="h-3 w-24 bg-gray-300 rounded "></div>
          </div>
        </div>
        <hr className="border-gray-300" />
      </div>
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-3">
          <div className="h-4 w-32 bg-gray-300 rounded "></div>
         
        </div>
        <div className="h-12 w-full bg-gray-300 rounded "></div>
        <div className="flex gap-6 sm:gap-10 items-center">
          <div>
            <div className="h-4 w-16 bg-gray-300 rounded "></div>
            <div className="h-3 w-24 bg-gray-300 rounded  mt-1"></div>
          </div>
          <div>
            <div className="h-4 w-16 bg-gray-300 rounded "></div>
            <div className="h-3 w-24 bg-gray-300 rounded  mt-1"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ReviewCardSkeleton;
